@if (showDragHandle) {
  <mat-icon
    class="drag-handle"
    [title]="dragHandleTitle"
    [attr.aria-label]="dragHandleTitle"
    role="button"
    cdkDragHandle
    tabindex="0"
    (keydown)="onDragHandleKeydown($event)">{{ dragIconName }}</mat-icon>
}

<button class="delete-btn"
  [title]="deleteTitle"
  (click)="onDeleteClick()"
  [attr.aria-label]="deleteTitle"
  tabindex="0">
  <mat-icon>{{ deleteIconName }}</mat-icon>
</button>

@if (showLinkIcon) {
  <button
    class="link-btn"
    [title]="linkIconTitle"
    [attr.aria-label]="linkIconTitle"
    [appInlineEdit]="linkEditField"
    [inlineEditValue]="linkEditValue"
    [inlineEditEnabled]="linkEditEnabled"
    [inlineEditConfig]="linkEditConfig"
    [class.inline-editable-error]="linkEditError"
    (inlineEditChange)="onLinkEditChange($event)"
    tabindex="0">
    <mat-icon>{{ linkIconName }}</mat-icon>
  </button>
}